'use client';

import React from 'react';
import CosaServiceLayout from '@/components/CosaServiceLayout';

const serviceData = {
  slug: 'medecine-generale',
  icon: 'fa-solid fa-stethoscope',
  badge: 'Médecine Générale',
  title: 'Médecine Générale',
  subtitle: 'La spécialité clé de COSA, répondant à 80% des demandes de consultation',
  heroImage: '/assets/images/service_general_medicine.png',
  heroAlt: 'Médecin généraliste africain en consultation avec un patient dans la clinique COSA Abidjan',
  accentColor: '#0e5932',
  description: `La médecine générale est la spécialité fondamentale du centre COSA. Elle constitue le premier point de contact entre le patient et le système de soins, et est conçue pour répondre à 80% de l'ensemble des demandes de consultation. Nos médecins généralistes résidents assurent une prise en charge globale, continue et personnalisée de chaque patient.`,
  features: [
    { icon: 'fa-solid fa-user-doctor', title: 'Consultations Médicales', description: 'Consultations complètes avec un médecin généraliste résident, disponible du lundi au vendredi de 8h à 18h et le samedi de 8h à 14h.' },
    { icon: 'fa-solid fa-magnifying-glass-chart', title: 'Diagnostics Précis', description: 'Utilisation d\'equipements modernes : stethoscopes, tensiometètres, otoscopes, balances médicales et tablettes de dossiers patients.' },
    { icon: 'fa-solid fa-calendar-check', title: 'Suivi Médical Régulier', description: 'Suivi longitudinal de votre état de santé avec historique médical complet et plans de traitement personnalisés.' },
    { icon: 'fa-solid fa-file-medical', title: 'Bilans Annuels', description: 'Bilans de santé complets pour les particuliers et les entreprises partenaires, incluant examens cliniques et orientations spécialisées.' },
    { icon: 'fa-solid fa-pills', title: 'Prescriptions & Ordonnances', description: 'Prescriptions médicales, renouvellements d\'ordonnances et orientation vers les spécialistes appropriés selon les besoins.' },
    { icon: 'fa-solid fa-building-columns', title: 'Médecine d\'Entreprise', description: 'Suivi médical des employés d\'entreprises partenaires, consultations sur site et programmes de santé au travail.' },
  ],
  process: [
    { step: '01', title: 'Prise de Rendez-vous', description: 'Contactez-nous par téléphone, en ligne ou directement au centre COSA Ananeréraie.' },
    { step: '02', title: 'Accueil & Enregistrement', description: 'Notre équipe d\'accueil vous enregistre et prépare votre dossier médical.' },
    { step: '03', title: 'Consultation Médicale', description: 'Le médecin généraliste vous reçoit pour un examen clinique complet et personnalisé.' },
    { step: '04', title: 'Suivi & Orientation', description: 'Prescription, suivi ou orientation vers un spécialiste selon votre état de santé.' },
  ],
  stats: [
    { value: '80%', label: 'des consultations traitées' },
    { value: '1', label: 'salle dédiée équipée' },
    { value: '6j/7', label: 'disponibilité' },
    { value: '70+', label: 'ans d\'expertise' },
  ],
};

export default function MedecineGeneralePage() {
  return <CosaServiceLayout service={serviceData} />;
}
